/* eslint-disable react/jsx-props-no-spreading */
import { bool, func, string } from "prop-types";

import withDispatch from "../../../shared/HOCs/withDispatch/withDispatch";
import { tdpDetails } from "../../../shared/HOCs/withRedux";
import { putStatusWithPipelineAsThunk } from "../../Header/actions/thunks";
import { isUpdateAddressModal, setStatusLoading } from "../../Header/actions/creators";

import { WithShowPicker } from "../../../Transactions/components/shared/OptionsStatusCell/OptionsStatusCell";
import {
  LISTING_UUID,
  STATUS,
  STREET_ADDRESS,
  TYPE,
  IS_STATUS_LOADING,
} from "../../../shared/reduxRoutes/tdpDetailsRoutes";

const TDPOptionsStatusCell = ({
  type,
  status,
  onSetStatus,
  onUpdateAddressModal,
  onSetStatusLoading,
  uuid,
  streetAddress,
  isStatusLoading,
  ...props
}) => {
  const onSetStatusHandlr = (_status) => {
    if (_status === status) return;

    onSetStatusLoading(true);
    onSetStatus({
      preStatus: status,
      status: _status,
      streetAddress: streetAddress,
      uuid,
      type,
    });
  };

  return (
    <WithShowPicker
      {...props}
      transactionType={type}
      status={status}
      selectedStatus={onSetStatusHandlr}
      isLoading={isStatusLoading}
    />
  );
};

const WithStatePipelineOptionsStatusCell = tdpDetails({
  WrappedComponent: TDPOptionsStatusCell,
  states: [STREET_ADDRESS, TYPE, STATUS, LISTING_UUID, IS_STATUS_LOADING],
  aliases: ["streetAddress"],
});

export default withDispatch({
  WrappedComponent: WithStatePipelineOptionsStatusCell,
  actions: [putStatusWithPipelineAsThunk, isUpdateAddressModal, setStatusLoading],
  aliases: ["onSetStatus", "onUpdateAddressModal", "onSetStatusLoading"],
});

TDPOptionsStatusCell.propTypes = {
  type: string,
  status: string,
  onSetStatus: func,
  onUpdateAddressModal: func,
  onSetStatusLoading: func,
  streetAddress: string,
  uuid: string.isRequired,
  isStatusLoading: bool,
};

TDPOptionsStatusCell.defaultProps = {
  type: "buyer",
  status: "active",
  onSetStatus: () => {},
  streetAddress: null,
  onUpdateAddressModal: () => {},
  onSetStatusLoading: () => {},
  isStatusLoading: false,
};
